<template>
  <div class="deviceConfiguration">
    <el-card class="box-card" shadow="never">
      <el-button icon="el-icon-back" v-if="active !== -1" style="float: left;" type="primary" @click="setActive(-1)" :inline="true">返回项目列表</el-button>
      <div v-if="active !== -1 && isType !== 'detail'" style="width: 80%; margin: 0 auto;font-size: 14px;">
        <el-steps :active="active" align-center process-status="finish" finish-status="wait">
          <el-step title="选择设备" @click.native="setActive(0)"></el-step>
          <el-step title="设备参数绑定" @click.native="setActive(1)"></el-step>
        </el-steps>
      </div>
      <div v-show="active === -1">
        <el-form :inline="true">
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="addRow">新增配置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" ref="tbl" border max-height="600" style="width: 100%; margin-top: 10px;" tooltip-effect="dark">
          <el-table-column type="index" label="序号" width="100" fixed></el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="280" fixed show-overflow-tooltip></el-table-column>
          <el-table-column prop="gridName" label="并网点名称" width="180"></el-table-column>
          <el-table-column prop="equipTypeName" label="设备类型" width="180"></el-table-column>
          <el-table-column prop="equipListDesc" label="网关及设备描述" width="420">
            <template slot-scope="{ row }">
              <span v-html="newLine(row.equipListDesc)"></span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="180"></el-table-column>
          <el-table-column prop="operatorName" label="配置人" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="180" align="center">
            <template slot-scope="{ row }">
              <el-button class="btn" type="text" size="small" @click="toProjectDetail(row)">详情</el-button>
              <el-button class="btn" type="text" size="small" @click="toProjectConfig(row)">配置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :total="total" :page-sizes="pageList" :page-size="pages.size" layout="total, sizes, prev, pager, next, jumper" style="text-align: center; margin-top:20px"></el-pagination>
      </div>
      <SelectDevice v-if="active === 0" ref="selectDeviceComponent"
                    :id="id"
                    :projectId="projectId"
                    :isType="isType"
                    @custom-event="handleEvent"
      ></SelectDevice>
      <DeviceBind v-if="active === 1"
                  :id="id"
                  :projectId="projectId"
                  :isType="isType"
                  :selectedDeviceFormInfo="selectedDeviceFormInfo"
                  @closeBind="closeBind"
                  @save="saveDeviceBind"
      ></DeviceBind>
      <el-dialog
        title="提示"
        :visible.sync="errorDialogVisible"
        width="30%"
        center>
        <span>请确认 项目、并网点、设备类型、设备 是否已选</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="errorDialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import EQUIPMENTCONFIGAPI from '@/api/equipmentConfig';
  import SelectDevice from './selectDevice';
  import DeviceBind from './deviceBind';

  export default {
    components: {
      SelectDevice,
      DeviceBind,
    },
    data() {
      return {
        active: -1,         // -1-项目列表页、0-选择设备页、1-设备绑定/详情页
        isType: 'add',      // add-新增、edit-编辑、detail-详情

        pages: { page: 1, size: 10 },
        pageList: [10, 20, 30, 50, 100],
        total: 0,
        tableData: [],

        id: -1,             // (当前) 列表 id
        projectId: '',
        projectName: '',
        equipTypeName: '',
        selectedDeviceFormInfo: {},
        errorDialogVisible: false,
      };
    },
    computed: {},
    methods: {
      handleEvent(data) {
        this.selectedDeviceFormInfo = data
      },
      //保存数据
      saveDeviceBind(r){
        this.id = r
        this.isType = 'edit'
        console.log(r)
      },
      // 页面跳转
      setActive(v) {
        // 如果准备跳转设备绑定页，且当前不是设备绑定页面，且是新增状态，
        // 则需判断是否有项目信息、设备选择信息、设备类型信息，有则跳转，无则不能跳转
        if (v === 1 && this.active !== 1) {
          if (this.isType !== 'detail') {     // 无论编辑、配置，设备绑定页信息都由设备选择页信息生成
            // 将设备选择参数传至下一级
            this.$refs.selectDeviceComponent.commitSelectedFormInfo();
            if ( this.selectedDeviceFormInfo.projectId !== ''
              && this.selectedDeviceFormInfo.equipType !== -1
              && this.selectedDeviceFormInfo.gridId !== ''
              && this.selectedDeviceFormInfo.equipFitIds.length > 0) {
              this.active = 1;
            } else {
              // this.errorDialogVisible = true;
              this.$message.error("请确认 项目、并网点、设备类型、设备 是否已选?")
            }
          } else {
            this.active = 1;
          }
        }

        if (v === -1) {
          this.active = -1;
          this.getEquipConfigList();
        }

        if (v === 0) {
          this.active = 0;
        }
      },

      // 新增一行
      addRow() {
        this.isType = 'add';
        this.active = 0;
        this.id = -1;
        this.projectId = '';
        this.projectName = '';
        this.equipType = '';
        this.equipTypeName = '';
      },

      // 配置
      toProjectConfig(row) {
        this.isType = 'edit';
        this.active = 0;
        this.id = row.id;
        this.projectId = row.projectId;
        this.projectName = row.projectName;
        this.equipType = row.equipType;
        this.equipTypeName = row.equipTypeName;
      },

      // 详情页
      toProjectDetail(row) {
        this.isType = 'detail';
        this.active = 1;
        this.id = row.id;
        this.projectId = row.projectId;
        this.projectName = row.projectName;
        this.equipType = row.equipType;
        this.equipTypeName = row.equipTypeName;
      },

      handleSizeChange(v) {
        this.pages.size = v;
        this.getEquipConfigList();
      },

      handleCurrentChange(v) {
        this.pages.page = v;
        this.getEquipConfigList();
      },

      //查询项目列表(带分页)
      getEquipConfigList() {
        let self = this;
        let params = {
          pageNum: self.pages.page,
          pageSize: self.pages.size
        };
        EQUIPMENTCONFIGAPI.getEquipConfigList(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.tableData = res.data.data.dataList;
            this.total = res.data.data.totalCount;
            this.$nextTick(function () {
              self.$refs.tbl.doLayout();
            });
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },

      closeBind() {
        this.active = -1;
      },

      newLine(item) {
        if (item) {
          const equipDescArr = item.split(';');
          let newStr = '';
          for (let i = 0; i < equipDescArr.length; i++) {
            // 最后一个元素
            if (i === equipDescArr.length - 1) {
              newStr += '<span>';
              newStr += equipDescArr[i];
              newStr += '</span>';
            } else {
              newStr += '<span>';
              newStr += equipDescArr[i];
              newStr += '</span><br>';
            }
          }
          return newStr;
        }
      }
    },
    created() {
      this.getEquipConfigList();
    }
  };
</script>

<style lang="scss" scoped>
  .deviceConfiguration {
    .box-card {
      .btn {
        padding: 0;
        font-size: 12px !important;

        &span {
          font-size: 12px !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/deviceConfiguration/index.vue